import { apiClient } from "@apis/apiClient";

/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  getLastest() {
    return apiClient.get(`/rest/tou/current`);
  },

  signToU() {
    return apiClient.post(`/rest/tou/signed`);
  },

  getGTMContainerId() {
    return apiClient.get(`/rest/appsettings/getGTMContainerId`);
  },

  getCsrfName() {
    return apiClient.get(`/rest/appsettings/getCsrfName`);
  },

  getMessageOnLoginScreen() {
    return apiClient.get(`/rest/appsettings/getMessageOnLoginScreen`);
  },

  getMessageOnUserPage() {
    return apiClient.get(`/rest/appsettings/getMessageOnUserPage`);
  },

  isDemoEnvironment() {
    return apiClient.get(`/rest/appsettings/isDemoEnvironment`);
  },

  validOrgName(orgName: any) {
    return apiClient.get(`/rest/register/validOrgName/${orgName}`);
  },

  validUsername(userName: any) {
    return apiClient.get(`/rest/register/validUsername?username=${userName}`);
  },

  getPublicKey() {
    return apiClient.get(`/rest/register/pubkey`);
  },

  register(params: any) {
    return apiClient.post(`/rest/register`, params, {
      headers: { "content-type": "application/json" },
    });
  },

  cropImage(name: any, params: any) {
    return apiClient.post(`/rest/file/crop/${name}`, params, {
      headers: { "content-type": "multipart/form-data" },
    });
  },

  cropImage2(entityType: any, id: any, resourceType: any, name: any, params: any) {
    return apiClient.put(
      `/rest/file/${entityType}/${id}/${resourceType}/${name}`,
      params,
      {
        headers: { "content-type": "multipart/form-data" },
      }
    );
  },

  getBuildInfor(userName?: any) {
    return apiClient.get(`/rest/buildInfo`);
  },

  confirmRegistration(code: any) {
    return apiClient.get(`/rest/register/confirm?code=${code}`);
  },
};
